import {apiService} from '../apiService';

export const employeeService = apiService.injectEndpoints({
    endpoints: (builder) => {
        return {
            // AD-2725: the staff Groups tab
            getEmployeeGroups: builder.query({
                query: (staffId) => ({
                    url: `/employees/${staffId}/groups`
                }),
                transformResponse: (response) => response?.map(name => ({name}))
            }),
            getEmployeeById: builder.query({
                query: (staffId) => ({
                    url: `/employees/${staffId}`
                }),
                providesTags: (_) => ['EmployeeProfile'],
                transformErrorResponse: (_) => ({message: 'Failed to retrieve staff profile'}),
            }),
            getEmployeeByCurrentUser: builder.query({
                query: () => ({
                    url: '/employees/current'
                }),
                providesTags: (_) => ['EmployeeProfile'],
                // AD-2738: the status is kept, as 404 means the account is not yet linked to a staff profile
                transformErrorResponse: (response) => ({status: response?.status, message: 'Failed to retrieve profile information'}),
            }),
            getAllEmployees: builder.query({
                query: (body) => ({
                    url: '/employees/list',
                    method: 'POST',
                    data: body
                }),
                transformErrorResponse: (_) => ({message: 'Failed to retrieve staff profiles'}),
            }),
            getAllEmployeeProfiles: builder.query({
                query: ({body}) => ({
                    url: '/employees/all',
                    method: 'POST',
                    data: body
                }),
                transformErrorResponse: (_) => ({message: 'Failed to retrieve staff profiles'}),
            }),
            getAllActiveEmployeeProfiles: builder.query({
                query: ({body}) => ({
                    url: '/employees/active',
                    method: 'POST',
                    data: body
                }),
                transformErrorResponse: (_) => ({message: 'Failed to retrieve staff profiles'}),
            }),
            updateEmployeeProfile: builder.mutation({
                query: (body) => ({
                    url: '/employees/update',
                    method: 'PATCH',
                    data: body,
                }),
                invalidatesTags: ['EmployeeProfile']
            }),
            // AD-2790: the staff categories ticked on a member of staff, and the signed-in member of staff's own
            getEmployeeStaffCategories: builder.query({
                query: (staffId) => ({
                    url: `/employees/${staffId}/staff-categories`
                }),
                providesTags: (_) => ['EmployeeStaffCategories']
            }),
            getMyStaffCategories: builder.query({
                query: () => ({
                    url: '/employees/current/staff-categories'
                }),
                providesTags: (_) => ['EmployeeStaffCategories']
            }),
            updateEmployeeStaffCategories: builder.mutation({
                query: ({staffId, staffCategoryIds}) => ({
                    url: `/employees/${staffId}/staff-categories`,
                    method: 'PUT',
                    data: {staffCategoryIds},
                }),
                invalidatesTags: ['EmployeeStaffCategories', 'StaffCategories']
            }),
        };
    },
});

export const {
    useGetEmployeeByIdQuery,
    useGetEmployeeGroupsQuery,
    useGetEmployeeByCurrentUserQuery,
    useGetAllEmployeesQuery,
    useGetAllEmployeeProfilesQuery,
    useGetAllActiveEmployeeProfilesQuery,
    useLazyGetAllActiveEmployeeProfilesQuery,
    useLazyGetAllEmployeeProfilesQuery,
    useUpdateEmployeeProfileMutation,
    useGetEmployeeStaffCategoriesQuery,
    useGetMyStaffCategoriesQuery,
    useUpdateEmployeeStaffCategoriesMutation
} = employeeService;
